import { render } from "./PainelPerfil.vue?vue&type=template&id=ca1cee7c&scoped=true"
import script from "./PainelPerfil.vue?vue&type=script&lang=js"
export * from "./PainelPerfil.vue?vue&type=script&lang=js"

import "./PainelPerfil.vue?vue&type=style&index=0&id=ca1cee7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1cee7c"]])

export default __exports__